<template>
  <md-button
    :class="{ 'md-icon-button': true, 'fab-button': true, 'hide': hidden }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <md-icon>
      <slot />
    </md-icon>
  </md-button>
</template>

<script>
export default {
  name: "FabButton",
  props: {
    hidden: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style scoped lang="scss">

.fab-button {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 100;

  width: 60px;
  height: 60px;
  border-radius: 50px;

  box-shadow: 2px 2px 3px rgba(0 0 0 / 0.5);
  background: linear-gradient(60deg, #66bb6a, #43a047);

  transform: scale(1) rotate(0deg);
  transition: transform 200ms cubic-bezier(0.42, 0, 0.75, 1.54);

  &.hide {
    transform: scale(0) rotate(-90deg);
  }
}
</style>
